import { useTranslation } from 'react-i18next';
import { UserCircle } from '@/design-system/icons';
import { getDaysAgo } from '@/utils/dateUtils';
interface UserProfileHeaderProps {
  username: string;
  email: string;
  registerDate: string;
  isManagedUser: boolean;
  managedByCompanyName?: string;
}


export function UserProfileHeader({
  username,
  email,
  registerDate,
  isManagedUser,
  managedByCompanyName,
}: UserProfileHeaderProps) {
  const { t } = useTranslation();
  const daysAgo = getDaysAgo(registerDate);

  let managedText = null;
  if (isManagedUser && managedByCompanyName) {
    managedText = t('userProfile.managedBy', { company: managedByCompanyName });
  } else if (isManagedUser) {
    managedText = t('contact.managedByCompany')
  }

  return (
    <div className="flex flex-col items-center text-center py-4">
      <div className="w-16 h-16 rounded-full bg-surface-darker flex items-center justify-center mb-3">
        <UserCircle className="w-10 h-10 text-onbackground" />
      </div>
      <h3 className="text-lg font-semibold">{username}</h3>
      <p className="text-sm opacity-50">{email}</p>
      <p className="text-sm opacity-50 mt-1">
        {t('userProfile.registeredDaysAgo', { count: daysAgo })}
      </p>
      {managedText && (
        <p className="text-xs text-primary mt-1">
          {managedText}
        </p>
      )}
    </div>
  );
}
